import { render, staticRenderFns } from "./us_share.vue?vue&type=template&id=98906e8c&scoped=true&"
import script from "./us_share.vue?vue&type=script&lang=ts&"
export * from "./us_share.vue?vue&type=script&lang=ts&"
import style0 from "./us_share.vue?vue&type=style&index=0&id=98906e8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98906e8c",
  null
  
)

export default component.exports